<template>
  <div>
    <filter-event
      :range="range"
      v-model="event"/>
    <div class="mt-3"> Уточните изъятую сумму</div>
    <filter-range v-model="deliveryMoney"/>
    <div class="mt-3"> Уточните внесенную сумму для сдачи</div>
    <filter-range v-model="depositMoney"/>

  </div>
</template>

<script>
  import { omitBy, isEmpty, isEqual } from 'lodash'

  export default {
    props: {
      range: {type: Object},
      value: {
        type: Object,
        default: () => {
          return {}
        },
      },
    },
    data () {
      return {
        event: {
          number: this.value.number || {},
          date: this.value.date || {}
        },
        deliveryMoney: this.value.deliveryMoney || {},
        depositMoney: this.value.depositMoney || {},
      }
    },
    computed: {
      preparedInput () {
        return omitBy({
          number: this.event.number,
          date: this.event.date,
          depositMoney: this.depositMoney,
          deliveryMoney: this.deliveryMoney,
        }, isEmpty)
      },
    },

    watch: {
      value (input) {
        this.event = {
          number: input.number || {},
          date: input.date || {}
        }
        this.deliveryMoney = input.deliveryMoney || {}
        this.depositMoney = input.depositMoney || {}
      },

      preparedInput: {
        handler (newVal, oldVal) {
          if (!isEqual(newVal, oldVal)) {
            this.$emit('input', this.preparedInput)
          }
        },
        deep: true,
      },
    },
  }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/filter-event-encashment.vue